import axios from "axios";

const SESSION_STORAGE_KEY = "sc_session_id";

const SUBJECT_TYPES = ["commerce", "ally"];
const ACTION_TYPES = [
  "image_click",
  "whatsapp_primary",
  "whatsapp_secondary",
  "card_info",
  "slide_info",
  "external_info",
  "map_click",
  "comment_created",
  "slider_view",
  "list_view",
  "info_click",
  "click_share",
  "benefit_created",
];

const generateUuid = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  const template = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
  return template.replace(/[xy]/g, (char) => {
    const random = (Math.random() * 16) | 0;
    const value = char === "x" ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
};

const detectDeviceType = () => {
  if (typeof navigator === "undefined") {
    return "desktop";
  }
  const userAgent = navigator.userAgent || "";
  return /Mobi|Android|iPhone|iPad|iPod/i.test(userAgent) ? "mobile" : "desktop";
};

export const ensureSessionId = () => {
  if (typeof window === "undefined") {
    return generateUuid();
  }
  const stored = window.localStorage.getItem(SESSION_STORAGE_KEY);
  if (stored) {
    return stored;
  }
  const newId = generateUuid();
  window.localStorage.setItem(SESSION_STORAGE_KEY, newId);
  return newId;
};

const shouldRetry = (error) => {
  if (!axios.isAxiosError(error)) {
    return false;
  }
  return !error.response;
};

const postEvent = async (payload, attempt = 0) => {
  try {
    await axios.post("/api/metrics/events", payload, {
      timeout: 2500,
      headers: {
        "X-Session-Id": ensureSessionId(),
      },
    });
  } catch (error) {
    if (attempt < 1 && shouldRetry(error)) {
      await postEvent(payload, attempt + 1);
      return;
    }
    if (axios.isAxiosError(error)) {
      console.warn("Metrics event tracking failed", error.message);
    } else {
      console.warn("Metrics event tracking failed", error);
    }
  }
};

export const trackEvent = async (subjectType, subjectId, action, meta = {}) => {
  if (typeof window === "undefined") {
    return;
  }

  if (!SUBJECT_TYPES.includes(subjectType)) {
    console.warn(`Unsupported subject type: ${subjectType}`);
    return;
  }

  if (!ACTION_TYPES.includes(action)) {
    console.warn(`Unsupported action: ${action}`);
    return;
  }

  const enrichedMeta = {
    referrer: typeof document !== "undefined" ? document.referrer || null : null,
    device: detectDeviceType(),
    ...meta,
  };

  const payload = {
    subject_type: subjectType,
    subject_id: subjectId,
    action,
    meta: enrichedMeta,
  };

  await postEvent(payload);
};

export const isSupportedAction = (action) => ACTION_TYPES.includes(action);

export const useMetrics = () => ({
  ensureSessionId,
  trackEvent,
  isSupportedAction,
});

export default useMetrics;
